import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import Millimetre from "../../../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Traegheitsradius({ traegheitsradius }) {
  const { t } = useTranslation("translation");

  const TraegheitsradiusFormula = `\\displaystyle i = \\sqrt{\\frac{I}{A_{s}}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.dinEN1993.verification.radiusInertia")}</p>}
      formulaValue={
        <ToolTip
          id={"TraegheitsradiusFormula"}
          type={IconType.FORMULA}
          formula={TraegheitsradiusFormula}
        />
      }
      indicesValue={<span>i</span>}
      inputValue={<span className="input">{ConvertToString(traegheitsradius, 2)}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default Traegheitsradius;
